import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="py-12 border-t border-border">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-2">
            <div className="h-7 w-7 rounded-full bg-primary flex items-center justify-center">
              <span className="text-primary-foreground font-heading font-bold text-xs">SV</span>
            </div>
            <span className="font-heading font-bold text-foreground">Senda de Vida</span>
          </div>

          <nav className="flex items-center gap-6 text-sm text-muted-foreground">
            <a href="#hero">Inicio</a>
            <a href="#featured">Catálogo</a>
            <a href="#faq">FAQ</a>
            <Link to="/admin/dashboard">Admin</Link>
          </nav>

          <p className="text-xs text-muted-foreground">© 2025 Senda de Vida. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
}
